import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * One label-over-value pair in the page header's context row, shared across the detail
 * pages so everything in those rows reads the same.
 *
 * `action` puts a control at the right end of the label's own line, for a field whose
 * value needs one (Line Items and its sort). It is expected to size itself within the
 * caption's line box, so a field carrying one keeps its label on the same baseline as
 * the fields beside it.
 */
export function HeaderField({
  label,
  children,
  caption,
  action,
}: {
  label: string;
  children: ReactNode;
  caption?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Box minWidth={0}>
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography variant="caption" color="text.secondary" lineHeight={1.4}>
          {label}
        </Typography>
        {action}
      </Box>
      {children}
      {caption ? (
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          lineHeight={1.4}
          component="div"
        >
          {caption}
        </Typography>
      ) : null}
    </Box>
  );
}
